export default function Loader() {
  return (
    <div className="loader-page">
      <div className="loader-ring" />
      <div className="loader-dots">
        <span className="loader-dot" />
        <span className="loader-dot" />
        <span className="loader-dot" />
      </div>
      <p className="loader-text">Verifying your store&hellip;</p>
    </div>
  );
}
